import request from '../../utils/request';
import { getURL } from '../../utils/apiURLBuilder';
import moment from 'moment';

export function getUsers(params = {}) {
  const body = {
    service: 'OnboardPendienteGet',
    params
  }

  return request.post(getURL(), body);
}

export function getUserById(usuarioNroDeDocumento, rolCod) {
  const body = {
    service: 'OnboardPendienteGet',
    params: {
      usuarioNroDeDocumento,
      rolCod
    }
  }

  return request.post(getURL(), body);
}

export function getUserStatusById(id) {
  const body = {
    service: 'RegistroXUsuarioGet',
    params: {
      usuarioId: id,
      registroXUsuarioFH: moment().format('YYYY-MM-DD'),
    }
  }

  return request.post(getURL(), body);
}

export function getUserRegisters() {
  const body = {
    service: 'RegistroGet',
    params: {
      registroRequiereBO: 'Y'
    }
  }

  return request.post(getURL(), body);
}

export function getUserInfo(usuarioId, service, extra) {
  const body = {
    service,
    params: {
      usuarioId,
      ...extra
    }
  }

  return request.post(getURL(), body);
}

export function updateUserInfo(params, service) {
  const body = {
    service,
    params
  }

  return request.post(getURL(), body);
}

export function getProvinces() {
  const body = {
    service: "ProvinciaGet",
    params: {}
  }

  return request.post(getURL(), body);
}

export function getLocations(provinciaId) {
  const body = {
    service: "LocalidadGet",
    params: {
      provinciaId
    }
  }

  return request.post(getURL(), body);
}



// WEBPACK FOOTER //
// ./src/state/users/users.services.js